import fetch from 'auth/FetchInterceptor'

const AuthService = {}

// Unified Login - role is determined by backend based on user type
AuthService.login = function (email, password) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: { email, password }
	})
}

// User Signup/Register (not used - agents/managers are created by admins)
AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

// Send activation OTP (not used - activation is done via email link)
AuthService.sendActivationOtp = function (email) {
	return fetch({
		url: '/auth/send-activation-otp',
		method: 'post',
		data: { email }
	})
}

// Verify OTP code
AuthService.verifyOtp = function (email, code, type) {
	return fetch({
		url: '/auth/verify-otp',
		method: 'post',
		data: { email, code, type }
	})
}

// Activate account and set password
AuthService.activateAccount = function (email, code, password) {
	return fetch({
		url: '/auth/activate-account',
		method: 'post',
		data: { email, code, password }
	})
}

// Request password reset (send OTP)
AuthService.forgotPassword = function (email) {
	return fetch({
		url: '/auth/forgot-password',
		method: 'post',
		data: { email }
	})
}

// Reset password after OTP verification
AuthService.resetPassword = function (email, code, newPassword, confirmPassword) {
	return fetch({
		url: '/auth/reset-password',
		method: 'post',
		data: { email, code, newPassword, confirmPassword }
	})
}

// Admin Login - uses /auth/admin/login endpoint (not /auth/login)
AuthService.loginAdmin = function (email, password) {
	return fetch({
		url: '/auth/admin/login',
		method: 'post',
		data: { email, password }
	})
}

// Admin Request password reset (send OTP)
AuthService.forgotPasswordAdmin = function (email) {
	return fetch({
		url: '/auth/admin/forgot-password',
		method: 'post',
		data: { email }
	})
}

// Admin Verify OTP code
AuthService.verifyOtpAdmin = function (email, code, type) {
	return fetch({
		url: '/auth/admin/verify-otp',
		method: 'post',
		data: { email, code, type }
	})
}

// Admin Reset password after OTP verification
AuthService.resetPasswordAdmin = function (email, code, newPassword, confirmPassword) {
	return fetch({
		url: '/auth/admin/reset-password',
		method: 'post',
		data: { email, code, newPassword, confirmPassword }
	})
}

// Logout — asks the backend to clear the httpOnly auth cookie
AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

export default AuthService;
